/* tslint:disable */
/* eslint-disable */
/**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Epoch,
    EpochFromJSON,
    EpochFromJSONTyped,
    EpochToJSON,
    EpochListAllOf,
    EpochListAllOfFromJSON,
    EpochListAllOfFromJSONTyped,
    EpochListAllOfToJSON,
    List,
    ListFromJSON,
    ListFromJSONTyped,
    ListToJSON,
} from './';

/**
 * 
 * @export
 * @interface EpochList
 */
export interface EpochList {
    /**
     * The total number of records that match the query, i.e. the number of records
     * the query would return with limit=infinity.
     * @type {number}
     * @memberof EpochList
     */
    total_count: number;
    /**
     * Whether total_count is clipped for performance reasons.
     * @type {boolean}
     * @memberof EpochList
     */
    is_total_count_clipped: boolean;
    /**
     * 
     * @type {Array<Epoch>}
     * @memberof EpochList
     */
    epochs: Array<Epoch>;
}

export function EpochListFromJSON(json: any): EpochList {
    return EpochListFromJSONTyped(json, false);
}

export function EpochListFromJSONTyped(json: any, ignoreDiscriminator: boolean): EpochList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total_count': json['total_count'],
        'is_total_count_clipped': json['is_total_count_clipped'],
        'epochs': ((json['epochs'] as Array<any>).map(EpochFromJSON)),
    };
}

export function EpochListToJSON(value?: EpochList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total_count': value.total_count,
        'is_total_count_clipped': value.is_total_count_clipped,
        'epochs': ((value.epochs as Array<any>).map(EpochToJSON)),
    };
}


